import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetEmployeesQuery,
  useSearchJobTitlesQuery,
} from '../../../../../utils/api_service/jobOpeningsApi';
import { JobOpeningsContext } from '../../../../../utils/contexts/JobOpening';
import { SelectOptions } from '../../../../../utils/types/react_select_types';
import { useJobOpeningNavigation } from '../../Hooks/useJobOpeningNavigation';
import { userToSelectOption } from '../functions/jobOpeningTransformers';
import { IJobOpeningDetails } from '../Interfaces/jobOpeningDetails.interface';

export const useJobOpeningDetailsState = (props: IJobOpeningDetails) => {
  const { id } = useParams<{ id: string }>();
  const {
    jobOpeningElements,
    completedJobOpeningDetails,
    setCompletedJobOpeningDetails,
  } = useContext(JobOpeningsContext);
  const { currentSubTab, navigateToSubTab } = useJobOpeningNavigation();

  // RTK Queries
  const { data: employeesData, isLoading: isEmployeesLoading } = useGetEmployeesQuery({
    searchTerm: '',
    page: 1,
    limit: 100,
  });

  const { data: jobTitleData, isLoading: isJobTitlesLoading } = useSearchJobTitlesQuery('');

  const jobTitleList = jobTitleData || [];
  const defaultEmployeeUserList = employeesData?.employee || [];
  const isLoading = isEmployeesLoading || isJobTitlesLoading;

  // States to persist the labels for hiring manager and recruiter
  const [hiringManagerOptions, setHiringManagerOptions] = useState<SelectOptions[] | undefined>(undefined);
  const [internalRecruiterOptions, setInternalRecruiterOptions] = useState<SelectOptions[] | undefined>(undefined);

  const editable = !completedJobOpeningDetails.includes('CV Ingestion');

  const completedElement = () => {
    if (!completedJobOpeningDetails.includes(currentSubTab)) {
      setCompletedJobOpeningDetails([
        ...completedJobOpeningDetails,
        currentSubTab,
      ]);
    }
  };

  useEffect(() => {
    if (props.jobRequisition?.hiringManager && props.jobRequisition.hiringManager.length > 0 && !hiringManagerOptions) {
      const options = props.jobRequisition.hiringManager
        .map(userToSelectOption)
        .filter((opt): opt is SelectOptions => opt !== null);
      if (options.length > 0) setHiringManagerOptions(options);
    }

    if (props.jobRequisition?.internalRecruiter && props.jobRequisition.internalRecruiter.length > 0 && !internalRecruiterOptions) {
      const options = props.jobRequisition.internalRecruiter
        .map(userToSelectOption)
        .filter((opt): opt is SelectOptions => opt !== null);
      if (options.length > 0) setInternalRecruiterOptions(options);
    }
  }, [props.jobRequisition, hiringManagerOptions, internalRecruiterOptions]);

  return {
    id,
    currentSubTab,
    navigateToSubTab,
    jobOpeningElements,
    completedJobOpeningDetails,
    jobTitleList,
    defaultEmployeeUserList,
    isLoading,
    editable,
    completedElement,
    hiringManagerOptions,
    setHiringManagerOptions,
    internalRecruiterOptions,
    setInternalRecruiterOptions,
  };
};
